module.exports = __webpack_public_path__ + "static/media/cto.6a50021c.svg";